import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import coreStyles from 'react-awesome-slider/src/core/styles.scss';
import animationStyles from 'react-awesome-slider/src/styled/fold-out-animation/fold-out-animation.scss';


import galleryStyle from "assets/jss/material-kit-react/views/landingPageSections/galleryStyle.jsx";

function importAll(r) {
  return r.keys().map(r);
}
const images = importAll(require.context('assets/img/gallery/', false, /\.(png|jpe?g|svg)$/));

let allimages = []

images.forEach(function(n) {
  let newimage = {
   "source": n
  }
  allimages.push(newimage);
});


console.log(allimages)

class Gallery extends React.Component {
  render() {

    return (
      <div id="gallery" >
        <div id="galleryAnchor" style={{position: "relative",top: "-150px"}} />
        <AwesomeSlider
          animation="scaleOutAnimation"
          cssModule={[coreStyles, animationStyles]}
          media={allimages}
        />
      </div>
    );
  }
}
export default withStyles(galleryStyle)(Gallery);
